// mutation 常量

export const SET_SINGER = 'SET_SINGER'

export const SET_PLAYING_STATE = 'SET_PLAYING_STATE'

export const SET_FULL_SCREEN = 'SET_FULL_SCREEN'

export const SET_PLAYLIST = 'SET_PLAYLIST'

export const SET_SEQUENCE_LIST = 'SET_SEQUENCE_LIST'

export const SET_MODE = 'SET_MODE'

export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX'

export const SET_SONGLIST = 'SET_SONGLIST'

export const SET_RANKLIST = 'SET_RANKLIST'

export const SET_SEARCHHISTORY = 'SET_SEARCHHISTORY'

export const SET_PLAYHISTORY = 'SET_PLAYHISTORY'

export const SET_FAVORITE_LIST = 'SET_FAVORITE_LIST'




// WEBPACK FOOTER //
// ./src/store/mutations-type.js